
import { uncurry4, uncurry2, curry4 } from "../fable-library-js.5.3.0/Util.js";
import { ProgramModule_withSetState, ProgramModule_view } from "../Fable.Elmish.5.0.2/program.fs.js";
import * as client from "react-dom/client";
import { Common_lazyView2With } from "./common.fs.js";

export function Program_Internal_withReactBatchedUsing(lazyView2With, placeholderId, program) {
    let lastRequest, root;
    const render = curry4(lazyView2With)((x) => ((y) => (x === y)))(ProgramModule_view(program));
    return ProgramModule_withSetState(uncurry2((lastRequest = undefined, (root = client.createRoot(document.getElementById(placeholderId)), (model) => ((dispatch) => {
        if (lastRequest != null) {
            const r = lastRequest;
            window.cancelAnimationFrame(r);
        }
        lastRequest = window.requestAnimationFrame((_arg) => {
            root.render(render(model)(dispatch));
        });
    })))), program);
}

export function Program_Internal_withReactSynchronousUsing(lazyView2With, placeholderId, program) {
    let root;
    const render = curry4(lazyView2With)((x) => ((y) => (x === y)))(ProgramModule_view(program));
    return ProgramModule_withSetState(uncurry2((root = client.createRoot(document.getElementById(placeholderId)), (model) => ((dispatch) => {
        root.render(render(model)(dispatch));
    }))), program);
}

export function Program_Internal_withReactHydrateUsing(lazyView2With, placeholderId, program) {
    let root;
    const render = curry4(lazyView2With)((x) => ((y) => (x === y)))(ProgramModule_view(program));
    return ProgramModule_withSetState(uncurry2((root = undefined, (model) => ((dispatch) => {
        if (root != null) {
            const root_1 = root;
            root_1.render(render(model)(dispatch));
        }
        else {
            root = client.hydrateRoot(document.getElementById(placeholderId), render(model)(dispatch));
        }
    }))), program);
}

/**
 * Renders React root component inside html element identified by placeholderId.
 * Uses `requestAnimationFrame` to batch updates to prevent drops in frame rate.
 * NOTE: This may have unexpected effects in React controlled inputs, see https://github.com/elmish/react/issues/12
 */
export function Program_withReactBatched(placeholderId, program) {
    return Program_Internal_withReactBatchedUsing(uncurry4((equal) => ((view) => Common_lazyView2With(uncurry2(equal), uncurry2(view)))), placeholderId, program);
}

/**
 * Renders React root component inside html element identified by placeholderId.
 * New renders are triggered immediately after an update.
 */
export function Program_withReactSynchronous(placeholderId, program) {
    return Program_Internal_withReactSynchronousUsing(uncurry4((equal) => ((view) => Common_lazyView2With(uncurry2(equal), uncurry2(view)))), placeholderId, program);
}

/**
 * Renders React root component inside html element identified by placeholderId using `React.hydrate`.
 */
export function Program_withReactHydrate(placeholderId, program) {
    return Program_Internal_withReactHydrateUsing(uncurry4((equal) => ((view) => Common_lazyView2With(uncurry2(equal), uncurry2(view)))), placeholderId, program);
}

//# sourceMappingURL=react.fs.js.map
